import type { enKaohsiung } from './en.kaohsiung';

/** Kaohsiung en castellano. Las frases de práctica de inglés se mantienen en inglés. */
export const esKaohsiung: typeof enKaohsiung = {
  kaohsiung: {
    mapNames: { kaohsiung: 'Kaohsiung' },
    zones: {
      kh_zuoying: 'Estación de alta velocidad de Zuoying',
      kh_lotus: 'Estanque del Loto',
      kh_yancheng: 'Barrio antiguo de Yancheng',
      kh_loveRiver: 'Río del Amor',
      kh_formosa: 'Bulevar Formosa',
      kh_liuhe: 'Mercado nocturno de Liuhe',
      kh_pier2: 'Centro de arte Pier-2',
      kh_harbor: 'Puerto de Kaohsiung',
    },
    objects: {
      kh_hsr: 'Estación de alta velocidad · Zuoying',
      kh_mrtZuoying: 'KMRT · Zuoying (R16)',
      kh_mrtFormosa: 'KMRT · Bulevar Formosa',
      kh_mrtYancheng: 'KMRT · Yanchengpu (O2)',
      kh_lotusView: 'Mirador del Estanque del Loto',
      kh_dragon: 'Pagodas del Dragón y el Tigre',
      kh_dome: 'Cúpula de Luz',
      kh_papaya: 'Puesto de batido de papaya',
      kh_oyster: 'Puesto de tortilla de ostras',
      kh_squid: 'Puesto de calamar a la brasa',
      kh_loveBoat: 'Taquilla del Barco del Amor',
      kh_pier2: 'Almacén de Pier-2',
      kh_giants: 'Estatuas gigantes',
      kh_lrt: 'Parada del tranvía · Pier-2',
      kh_lrtHamasen: 'Parada del tranvía · Hamasen',
      kh_ferry: 'Ferri a Cijin',
      kh_icecream: 'Carrito de helados de Cijin',
      kh_tower85: 'Mirador de la Torre 85',
    },
    npc: {
      kh_stationStaff: 'Personal de la estación',
      kh_monk: 'Monje',
      kh_domeGuide: 'Guía de la Cúpula',
      kh_papayaVendor: 'Vendedor de batido de papaya',
      kh_oysterAuntie: 'Tía de las tortillas de ostras',
      kh_boatman: 'Capitán del Barco del Amor',
      kh_cyclist: 'Ciclista',
      kh_artist: 'Artista de Pier-2',
      kh_fisher: 'Pescador de Cijin',
      kh_surfer: 'Surfista',
      kh_kiteKid: 'Niño de la cometa',
      kh_kiteGirl: 'Niña de la cometa',
    },
    items: {},

    closed: 'El puesto está cerrado. ¡El mercado nocturno de Liuhe despierta a las cinco de la tarde!',
    kmrt: {
      name: 'KMRT',
      ask: 'Which exit is this, please?',
      text: 'El metro de Kaohsiung (高雄捷運): la línea roja va de norte a sur y la naranja de este a oeste. Se cruzan en Bulevar Formosa.',
      to: { zuoying: '🔴 Zuoying — estación de alta velocidad y Estanque del Loto', formosa: '🔴🟠 Bulevar Formosa — Cúpula de Luz y Liuhe', yancheng: '🟠 Yanchengpu — Río del Amor y Pier-2' },
      riding: '¡Cuidado con el hueco! El tren se desliza bajo la ciudad…',
    },
    lrt: {
      text: 'El tranvía circular de Kaohsiung (高雄輕軌) fue el primer tren ligero de Taiwán (2015). No tiene cables aéreos: ¡los tranvías se cargan en cada parada en veinte segundos!',
      to: { pier2: '🚈 Ir a Pier-2 (C12)', hamasen: '🚈 Ir a Hamasen y el ferri (C14)' },
      ask: '❓ ¿Por qué no hay cables?',
      riding: '¡Din din! El tranvía verde zumba sobre la vía de césped.',
      q: 'Why does this tram have no overhead wires?',
      a: ['It charges its batteries at every stop.', 'It is pulled by horses.', 'It runs on wind power.'],
      right: '¡Eso es! Los supercondensadores se cargan en segundos mientras la gente sube y baja.',
      wrong: 'Mira el techo cuando se detiene: un bracito se levanta para cargar…',
    },
    dome: {
      text: 'La Cúpula de Luz (光之穹頂) está bajo tus pies, en la estación de Bulevar Formosa: 30 metros de diámetro, 4.500 piezas de vidrio de colores, la obra de vidrio más grande del mundo. Cuenta una historia de agua, tierra, luz y fuego.',
      ask: '🌈 Aprende un dato (inglés)',
      q: 'What is the Dome of Light made of?',
      a: ['Coloured glass — four thousand five hundred pieces.', 'Plastic bottles.', 'Paper lanterns.'],
      right: '¡Sí! El artista italiano Narcissus Quagliata trabajó en ella cuatro años.',
      wrong: 'Mira los colores que brillan a través de las conchas de cristal sobre la escalera…',
    },
    dragon: {
      text: 'Las Pagodas del Dragón y el Tigre (龍虎塔) se alzan sobre el Estanque del Loto. Se ENTRA por la boca del dragón y se SALE por la boca del tigre: ¡así la mala suerte se vuelve buena!',
      ask: '🐉 ¿Por dónde se entra? (inglés)',
      q: 'Which mouth do you walk in through?',
      a: ['In through the dragon, out through the tiger.', 'In through the tiger, out through the dragon.', 'It doesn’t matter.'],
      right: '¡Exacto! Dragón al entrar, tigre al salir: ahora tienes buena suerte el resto del día.',
      wrong: '¡Cuidado! Al revés trae mala suerte. Primero el dragón…',
    },
    lotus: {
      text: 'El Estanque del Loto (蓮池潭) es un lago de 42 hectáreas rodeado de templos. En verano se pone rosa de flores de loto. Al otro lado del agua, la estatua de Xuantian Shangdi mide 72 metros: la estatua de un dios sobre el agua más alta del mundo.',
      look: '🔭 Mira por el telescopio',
      looked: 'Dragón y tigre, dos pabellones y un dios gigante con espada de pie sobre el agua. Pasa volando una garceta.',
      phrase: 'Look! A giant statue on the water!',
    },
    food: {
      papaya: { vendor: 'Papaya milk, fresh and cold! Large or small?', ok: 'A large papaya milk, please.', bad: ['Papaya. Milk. Now.', 'Give me the orange one.'], done: 'Dulce, cremoso y helado: Kaohsiung en un vaso. El vendedor guiña un ojo: “¡El mejor de Liuhe!”', price: 30 },
      oyster: { vendor: 'Oyster omelette! Hot off the griddle. With sweet sauce?', ok: 'Yes, please. One oyster omelette with sauce.', bad: ['Omelette! Fast!', 'Oysters. Mine.'], done: 'Bordes crujientes, centro tierno, ostras gordas y salsa dulce y picante. ¡Delicioso!', price: 35 },
      squid: { vendor: 'Grilled squid! Spicy or not spicy?', ok: 'Not spicy, please. One grilled squid.', bad: ['Squid. Give.', 'I want the whole sea.'], done: 'Ahumado, tierno, pintado con soja y sésamo. Te lo comes del palo como todo el mundo.', price: 40 },
      icecream: { vendor: 'Cijin ice cream! Mango, peanut or taro?', ok: 'One mango ice cream, please.', bad: ['Ice. Cream. Mango.', 'I want all of them for free.'], done: 'Frío y frutal, con brisa marina y una gaviota mirando tu cucurucho. ¡Perfecto!', price: 25 },
    },
    boat: {
      text: 'El Barco del Amor (愛之船) navega por el Río del Amor bajo los puentes. De noche las orillas se iluminan de rosa, violeta y azul.',
      buy: '🎫 Compra un billete (inglés)',
      q: 'How do you ask for a ticket politely?',
      a: ['Two tickets for the Love Boat, please.', 'Boat. Ticket. Now.', 'Take me somewhere.'],
      right: 'Te deslizas bajo los puentes. Las palmeras se mecen, los corazones brillan en las farolas y el capitán saluda a todos los barcos.',
      wrong: 'El capitán sonríe: “Could you say that more politely?”',
      price: 40,
      poor: 'No tienes monedas suficientes para el barco.',
    },
    pier2: {
      text: 'Centro de arte Pier-2 (駁二藝術特區): estos almacenes de ladrillo guardaban azúcar y harina de pescado para el puerto en los años 70. Tras años abandonados, en 2006 se convirtieron en talleres, galerías y una plaza para patinar.',
      ask: '🎨 Aprende un dato (inglés)',
      q: 'What were these buildings before they were an art centre?',
      a: ['Port warehouses for sugar and fish meal.', 'A train station.', 'A school.'],
      right: '¡Eso es! Ahora las viejas vías cruzan la plaza y los muros están llenos de murales.',
      wrong: 'Mira las puertas grandes y las vías en el suelo…',
    },
    giants: {
      text: 'Las estatuas gigantes de Pier-2: un trabajador del muelle y una pescadora, brillantes y cuadradotes, que recuerdan a la gente que construyó el puerto.',
      pose: '💪 Posa como un gigante',
      posed: '¡Brazos arriba, barbilla alta! Los turistas se ríen y te hacen fotos junto a los gigantes.',
      phrase: 'The worker is strong. The fisherwoman is brave.',
    },
    ferry: {
      text: 'El ferri Gushan–Cijin (鼓山渡輪) cruza el puerto hasta la isla de Cijin, con su faro, su playa de arena negra y su calle de marisco. ¡Las motos también suben a bordo!',
      ask: '⛴️ Aprende un dato (inglés)',
      q: 'How long does the ferry to Cijin take?',
      a: ['About five minutes.', 'Two hours.', 'All day.'],
      right: '¡Sí! Cinco minutos de travesía… y las motos entran primero.',
      wrong: 'Mira al otro lado del puerto: desde aquí se ve Cijin…',
    },
    tower: {
      text: 'La Torre 85 (高雄85大樓) mide 347 metros: dos patas y una torre central, con la forma del carácter 高 (gāo, “alto”), el primer carácter de Kaohsiung. Fue el edificio más alto de Taiwán hasta el Taipei 101.',
      ask: '🏙️ Aprende un dato (inglés)',
      q: 'Which Chinese character is the tower shaped like?',
      a: ['高 — “tall”, the first character of Kaohsiung.', '大 — “big”.', '山 — “mountain”.'],
      right: '¡Eso es! Dos patas y un centro alto, igual que 高.',
      wrong: 'Mira su forma: dos patas que sostienen una torre alta…',
    },

    talk: {
      kh_stationStaff: {
        intro: '¡Bienvenido a Kaohsiung! Aquí hace sol todo el año. ¿Te ayudo a encontrar algo?',
        q: 'How do you ask where the MRT is?',
        a: ['Excuse me, where is the MRT station?', 'MRT. Where.', 'Take me to the MRT!'],
        right: '¡Muy educado! La entrada del KMRT está en la plaza, a tu derecha.',
        wrong: 'Prueba a empezar con “Excuse me…”',
      },
      kh_domeGuide: {
        intro: '¡Bienvenido a Bulevar Formosa! Bajando la escalera está la Cúpula de Luz. ¿Adivinas para qué sirve?',
        q: 'Which of these happens under the Dome of Light?',
        a: ['Weddings — couples get married under the glass!', 'Swimming races.', 'Football matches.'],
        right: '¡Sí! Cada año hay parejas que eligen esta estación para sus fotos de boda.',
        wrong: 'Piensa en algo romántico, con colores y luz…',
      },
      kh_monk: [
        'Entra por el dragón y sal por el tigre. Despacio: en el Estanque del Loto no hay prisa.',
        'English practice: “Good morning.” — “Good morning. Peace be with you.”',
        'El loto nace del barro y se abre limpio al sol. Por eso lo queremos.',
      ],
      kh_papayaVendor: [
        'Las papayas de Kaohsiung son las más dulces: ¡el sol hace todo el trabajo!',
        'English practice: “Would you like ice in it?” — “Yes, please. Lots of ice!”',
        'Mi abuela abrió este puesto. ¡Misma receta, mismo ruido de batidora!',
      ],
      kh_oysterAuntie: [
        'Ostras frescas de la laguna cada mañana. ¡Crujiente por fuera, tierno por dentro!',
        'English practice: “Is it spicy?” — “Just a little.”',
        'Regla del mercado nocturno: come, pasea, ¡y vuelve a comer!',
      ],
      kh_boatman: [
        'English practice: “All aboard!” — eso digo cuando el barco está listo.',
        'El Río del Amor estaba sucio. ¡Ahora la gente rema, corre y canta karaoke en sus orillas!',
        'Treinta minutos río abajo y vuelta. Los puentes más bajos están junto al puerto.',
      ],
      kh_cyclist: [
        'English practice: “Passing on your left!”',
        'Se puede ir en bici desde el Río del Amor hasta el puerto y Pier-2: todo llano.',
        '¿Las palmeras del río? Se inclinan porque el viento del mar sopla cada tarde.',
      ],
      kh_artist: [
        'Pinto ballenas. Kaohsiung es una ciudad portuaria: aquí el mar está en todas partes.',
        'English practice: “What are you painting?” — “A whale, and a tram, and the sun.”',
        'Las vías viejas de la plaza llevaban azúcar a los barcos. Ahora pasan monopatines por encima.',
      ],
      kh_fisher: [
        'Vivo en Cijin. Cinco minutos en ferri, pero parece otra isla.',
        'English practice: “Did you catch anything?” — “A big one! It got away.”',
        'Cuando entran los barcos grandes, el agua sube. ¡Agárrate el sombrero!',
      ],
      kh_surfer: [
        'En Cijin hay olas en invierno y una playa de arena negra. ¡Los mejores atardeceres de Taiwán!',
        'English practice: “Can you swim?” — “Yes, I can. Can you surf?”',
        'El ferri lleva mi tabla gratis. Las motos pagan un poco más.',
      ],
      kh_kiteKid: [
        '¡Mi cometa es la del dragón! Tiene doce colas.',
        'English practice: “Hold the string tight!” — “I’ve got it!”',
      ],
      kh_kiteGirl: [
        'El viento del mar es perfecto por la tarde. Espera… ¡ahora!',
        'English practice: “Look how high it is!” — “Higher than the 85 tower!”',
      ],
    },
  },
};
